import React from 'react';
import { Navigate } from 'react-router-dom';
import { useOrgRole } from '../hooks/useOrgRole';

const BILLING_ROLES = new Set(['owner', 'admin']);

/**
 * Whether the current user may access Payments (org owner or admin).
 * Mirrors API ``view_billing`` / ``manage_billing`` for system roles.
 */
export function useOrgBillingAccess(): {
  allowed: boolean;
  isLoading: boolean;
} {
  const { role, isLoading } = useOrgRole();
  return { allowed: BILLING_ROLES.has(role), isLoading };
}

/** Route guard — org owner/admin required for Payments. */
export const RequireOrgBilling: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { allowed, isLoading } = useOrgBillingAccess();
  if (isLoading) return null;
  if (!allowed) {
    return <Navigate to="/agents" replace />;
  }
  return <>{children}</>;
};
